import {statisticsIndexTeamDetailData} from "@/api/home";
import {ElMessage} from "element-plus";
import {i18n} from "@/lang";

const homeEcharts = {
    namespaced: true, state: {
        statisticsTeamEmailVo: {},
        statisticsTeamEmailReplyVo: {},
        statisticsTeamCustomerAddVo: {},
        statisticsTeamCustomerDataVo: [],
        statisticsTeamCustomerDataVoType: [],
        statisticsTeamCustomerDataVoCountry: [],
        statisticsTeamMassEmailVo: [],
    }, getters: {}, mutations: {}, actions: {
        async getEmailEchartsApis({state}, payload) {
            const {type} = payload
            const res = await statisticsIndexTeamDetailData(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            if (type === 1) {
                state.statisticsTeamEmailVo = res.result.statisticsTeamEmailVo ? res.result.statisticsTeamEmailVo : {dateList: []}
            } else if (type === 2) {
                state.statisticsTeamEmailReplyVo = res.result.statisticsTeamEmailReplyVo ? res.result.statisticsTeamEmailReplyVo : {dateList: []}
            } else if (type === 3) {
                state.statisticsTeamCustomerAddVo = res.result.statisticsTeamCustomerAddVo ? res.result.statisticsTeamCustomerAddVo : {dateList: []}
            } else if (type === 4) {
                state.statisticsTeamCustomerDataVo = res.result.statisticsTeamCustomerDataVo ? res.result.statisticsTeamCustomerDataVo.map(item => {
                    if (item.name === "未填写") {
                        return {...item, name: i18n.global.t('select.empty')}
                    }
                    if (item.name === "其他来源") {
                        return {...item, name: i18n.global.t('other.origin.text')}
                    }
                    return item
                }) : []
            } else if (type === 5) {
                state.statisticsTeamCustomerDataVoType = res.result.statisticsTeamCustomerDataVo ? res.result.statisticsTeamCustomerDataVo.sort((a, b) => {
                    if (a.name === '未填写') return 1;   // a 放到后面
                    if (b.name === '未填写') return -1;  // b 放到后面
                    return 0;  // 其他保持原顺序
                }).map(item => {
                    if (item.name === "未填写") {
                        return {...item, name: i18n.global.t('select.empty')}
                    }
                    return item
                }) : []
            } else if (type === 6) {
                state.statisticsTeamCustomerDataVoCountry = res.result.statisticsTeamCustomerDataVo ? res.result.statisticsTeamCustomerDataVo : []
            } else if (type === 7) {
                state.statisticsTeamMassEmailVo = res.result.statisticsTeamMassEmailVo ? res.result.statisticsTeamMassEmailVo : []
            }
        }
    },
};

export default homeEcharts;
